export const SYNC_PROGRESS_UPDATE = 'SYNC_PROGRESS_UPDATE';
export const SYNC_PROGRESS_RESET = 'SYNC_PROGRESS_RESET';

export const SyncProgressAction = progress => ({
    type: SYNC_PROGRESS_UPDATE,
    payload: progress,
});

export const SyncProgressResetAction = () => ({
    type: SYNC_PROGRESS_RESET,
});
